<template>
  <div>
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">信息技术</div>
      <div class="t-t2box">
        <div class="t-t2">用技术创造商业价值</div>
      </div>
    </div>

    <div class="row3">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">开发服务</div>
        <br />
        <div class="t2">PC 移动 App 小程序 微信</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/home/APP@2x.png" alt="" />
          </div>
          <div class="text1">移动APP开发</div>

          <div class="text2">基于安卓系统和ios系统</div>
          <div class="text3">APP软件定制开发</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/home/XIAOCHENGXU@2x.png" alt="" />
          </div>
          <div class="text1">小程序开发</div>

          <div class="text2">微信小程序</div>
          <div class="text3">及内部系统的微信对接</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/home/WANGZHAN@2x.png" alt="" />
          </div>
          <div class="text1">网站制作</div>

          <div class="text2">电脑PC站+手机网站</div>
          <div class="text3">适应各类尺寸的终端屏幕</div>
        </div>
        <div class="item1">
          <div class="img">
            <img src="@/image/home/CUNCHU@2x.png" alt="" />
          </div>
          <div class="text1">分布式存储</div>

          <div class="text2">系统稳定可靠</div>
          <div class="text3">加密碎片数据 安全无忧</div>
        </div>
      </div>

      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>

    <div class="row4">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">我们的优势</div>
        <br />
        <div class="t2">致力于用技术创造商业价值</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <img src="@/image/products/xinxi/keshenqingruanzhu@2x.png" class="img1" alt="" />
        <img src="@/image/products/xinxi/beianjishangjia@2x.png" class="img2" alt="" />
        <img src="@/image/products/xinxi/jiaofuyuanma@2x.png" class="img4" alt="" />
        <img src="@/image/products/xinxi/jiagedi@2x.png" class="img5" alt="" />
        <img src="@/image/products/xinxi/yangeguifandekaifaliucheng@2x.png" class="img3" alt="" />
      </div>

      <div class="bt">按客户需求定制</div>
    </div>

    <div class="row5">
      <!-- 标题 -->
      <div class="title">
        <div class="t1">行业定制</div>
        <br />
        <div class="t2">覆盖市场主流行业，针对实际场景制定解决方案</div>
      </div>

      <!-- 内容 -->
      <div class="box1">
        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu3@2x.png" alt="" />
          </div>

          <div class="text1">企业</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu4@2x.png" alt="" />
          </div>

          <div class="text1">零售</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu5@2x.png" alt="" />
          </div>

          <div class="text1">母婴</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu6@2x.png" alt="" />
          </div>

          <div class="text1">超市</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu7@2x.png" alt="" />
          </div>

          <div class="text1">餐饮</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu8@2x.png" alt="" />
          </div>

          <div class="text1">酒店</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu9@2x.png" alt="" />
          </div>

          <div class="text1">景区</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu10@2x.png" alt="" />
          </div>

          <div class="text1">教育</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu11@2x.png" alt="" />
          </div>

          <div class="text1">医疗</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu12@2x.png" alt="" />
          </div>

          <div class="text1">政务</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu13@2x.png" alt="" />
          </div>

          <div class="text1">金融</div>

          <div class="line"></div>
        </div>

        <div class="item1">
          <div class="img">
            <img src="@/image/home/tu14@2x.png" alt="" />
          </div>

          <div class="text1">娱乐</div>

          <div class="line"></div>
        </div>
      </div>

      <!-- 立即咨询 -->
      <div class="zixun" @click="goBto">立即咨询</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DczxpIndex',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/products/xinxi/banner.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

// 顶部
.top {
  img {
    width: 100%;
  }
}

.row3 {
  height: 650px;

  position: relative;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 65px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 1.2px;
    }
  }

  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 650px;

    margin: 120px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;
    position: relative;

    .item1 {
      width: 280px;
      height: 320px;
      // border: 1px solid;
      margin-right: 40px;
      box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        width: 90px;
        height: 85px;
        margin: 45px auto 18px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .text1 {
        width: 250px;
        text-align: center;
        margin: 30px auto 16px auto;
        font-size: 18px;
        letter-spacing: 2px;
      }

      .text2 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 2px auto;
        font-size: 15px;
        color: #999999;
      }
      .text3 {
        letter-spacing: 2px;
        width: 250px;
        text-align: center;
        margin: 0px auto 10px auto;
        font-size: 15px;
        color: #999999;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;
      color: #4581fb;
      transition-timing-function: linear;
    }
  }

  .zixun {
    letter-spacing: 1px;
    position: absolute;
    bottom: 50px;
    width: 170px;
    left: 850px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    border: 1px solid #ffffff;
    color: #fff;
    border-radius: 6px;
  }
}

.row4 {
  height: 800px;
  background-color: #313131;
  position: relative;
  overflow: hidden;

  .title {
    margin-top: 40px;
    display: flex;
    color: #ffffff;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 95px;
      color: #ffffff;
      font-size: 15px;
      letter-spacing: 1px;
    }
  }

  // 内容
  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1500px;
    height: 380px;

    margin: 150px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;
  }
  .img1 {
    position: absolute;
    top: 20%;
    left: 42%;
  }
  .img2 {
    position: absolute;
    top: 38%;
    right: 18%;
  }
  .img3 {
    position: absolute;
    left: 56%;
    bottom: 10%;
  }
  .img4 {
    position: absolute;
    bottom: 10%;
    left: 30%;
  }
  .img5 {
    position: absolute;
    top: 38%;
    left: 18%;
  }

  .bt {
    background-color: #4581fb;
    position: absolute;
    font-size: 20px;
    top: 52%;
    width: 290px;
    left: 43%;
    height: 55px;
    line-height: 55px;
    text-align: center;
    letter-spacing: 1px;
    color: #fff;
    border-radius: 2px;
    border-radius: 24px;
  }
}

.row5 {
  height: 870px;
  overflow: hidden;
  position: relative;
  margin-bottom: 30px;
  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 115px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 1px;
    }
  }

  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1700px;
    height: 650px;

    margin: 80px auto 0 auto;
    box-sizing: border-box;
    padding-left: 150px;
    padding-top: 15px;

    .item1 {
      width: 200px;
      height: 210px;
      position: relative;
      // border: 1px solid;
      margin-right: 30px;
      box-shadow: 1px 1px 5px 3px #efefef;

      .img {
        position: absolute;
        top: 0;
        width: 200px;
        height: 210px;
        z-index: -100;

        img {
          background-color: #000;
          opacity: 2;
          width: 100%;
          height: 100%;
        }
      }
      .img::after {
        content: ' ';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.3;
      }

      .text1 {
        width: 200px;
        text-align: center;
        margin: 140px auto 16px auto;
        color: #ffffff;
        font-size: 22px;
        text-align: center;
        letter-spacing: 2px;
      }
      .line {
        background-color: #ffffff;

        height: 2px;
        width: 40px;
        margin: 10px auto;
      }
    }
    .item1:hover {
      transform: translate(0, -8px);
      transition-duration: 0.2s;

      transition-timing-function: linear;
    }
  }

  .zixun {
    letter-spacing: 1px;
    position: absolute;
    bottom: 50px;
    width: 170px;
    left: 850px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background-color: #4581fb;
    border: 1px solid #ffffff;
    color: #fff;
    border-radius: 6px;
  }
}

.row6 {
  height: 860px;
  overflow: hidden;
  position: relative;
  background-color: #f7f8fb;
  margin-bottom: 30px;

  .title {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    .t1 {
      margin: 0 auto;
      font-size: 30px;
      // word-spacing: 20px;
      letter-spacing: 3px;
    }
    .t2 {
      position: absolute;
      top: 115px;
      color: #999999;
      font-size: 15px;
      letter-spacing: 3px;
    }
  }

  .box1 {
    display: flex;
    // justify-content: space-around;
    flex-wrap: wrap;
    width: 1400px;
    height: 500px;
    margin: 100px auto 0 auto;
    box-sizing: border-box;

    .b1 {
      width: 50%;
      background-color: #ffffff;

      position: relative;

      .t1 {
        font-size: 120px;
        position: absolute;
        top: 60px;

        color: #4581fb;
      }

      .t2 {
        position: absolute;
        letter-spacing: 1px;
        line-height: 30px;
        font-size: 18px;
        left: 180px;
        top: 120px;
        color: #333333;
      }

      .t3 {
        color: #4581fb;
        position: absolute;
        bottom: 90px;
        font-size: 33px;
        left: 220px;
      }
    }

    .b2 {
      width: 50%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
